import React from 'react'

function Footer() {
    return (
        <div className='container' id='Footer'>
           <h4>built by Or Menashe - ormjbh@gmail.com ~ 2023</h4> 
        </div>
    )
}

export default Footer